import { first } from 'lodash'
import { log } from './utils'
import { CSV } from './csvparse'
import { FileAPI } from '../apis/FileAPI'
import {
    ADMIN_UPLOAD_FILES as ADMIN_UPLOAD_FILES_META,
    CLIENT_ROS_FILE as CLIENT_ROS_FILE_META,
    REUPLOAD_DELIVERABLE_FILES,
    REUPLOAD_ORIGINAL_FILES,
} from './contants'

export const DELIVERABLE_FILES = 'Deliverable-Files'
export const CLIENT_ROS_FILE = CLIENT_ROS_FILE_META
export const REUPLOAD_CLIENT_ROS_FILE = 'ReUpload-Client-ROS-File'
export const ADMIN_ROS_FILE = 'Admin-ROS-File'
export const REUPLOAD_ADMIN_ROS_FILE = 'ReUpload-Admin-ROS-File'
export const ADMIN_UPLOAD_FILES = ADMIN_UPLOAD_FILES_META
export const LEAD_FILE_PRIORITY = [
    ADMIN_UPLOAD_FILES,
    REUPLOAD_ORIGINAL_FILES,
    'Original-Files',
    REUPLOAD_CLIENT_ROS_FILE,
    CLIENT_ROS_FILE,
    REUPLOAD_ADMIN_ROS_FILE,
    ADMIN_ROS_FILE,
]
export const deliverableFiles = [
    REUPLOAD_CLIENT_ROS_FILE,
    CLIENT_ROS_FILE,
    ADMIN_ROS_FILE,
    REUPLOAD_ADMIN_ROS_FILE,
    ADMIN_UPLOAD_FILES,
    DELIVERABLE_FILES,
    REUPLOAD_DELIVERABLE_FILES,
]

export const isRos = ({ name }) => name.toLowerCase().includes('ros')
export const isSkipTrace = ({ name }) =>
    name.toLowerCase().includes('skip trace')

export const getFileMeta = (meta_data) => {
    const meta = meta_data.filter((item) => deliverableFiles.includes(item.key))
    return meta
}

export const getHighestPriorityLeadFileMeta = (meta_data = []) => {
    return LEAD_FILE_PRIORITY.map((key) =>
        meta_data.find((item) => item?.key === key && item?.value),
    ).find(Boolean)
}

export const getDeliverableFilesFromOrder = (order) => {
    let files = []
    order?.line_items.forEach((line) => {
        const fileMeta = getFileMeta(line?.meta_data)
        if (fileMeta.length > 0) {
            const firstFile = first(fileMeta)
            const link = String(firstFile.value || '')
            const files_ = link.split('\n').filter((file) => file != '')
            files_.forEach((file_) => {
                const file = getFileComponent(file_)
                if (file.length > 0) {
                    files.push(file)
                }
            })
        }
    })
    return files
}

export const getFileName = (link) => link.split('/').pop()

export const generateROSName = (link) => {
    const name = getFileName(link)
    return [name, `Client-ROS-${name}`]
}

export const generateSkipTraceName = (link, order) => {
    const name = getFileName(link)
    return [name, `${order.id}-skip-trace.csv`]
}

export const replaceFileName = (html, replace) => {
    return html.replace('Deliverable-List.csv', replace)
}

export const generateROSFile = (html) => {
    const [file, link] = generateSpecificFile(html)
    const [name, ros] = generateROSName(link)

    const rosFile = file.replace(name, ros)

    const rosLink = rosFile.match(/href='([^"]*)'/)[1]

    return `<a href="${rosLink}">Client-ROS-Deliverable-List.csv</a>`
}

export const generateSkipTraceFile = (html) => {
    const [file, link] = generateSpecificFile(html)
    const [name, skipTrace] = generateSkipTraceName(link)

    return replaceFileName(
        file.replace(name, `%23${skipTrace}`),
        'Download Skip Trace File',
    )
}

export const generateSpecificFile = (html) => {
    const file = getFirstfile(html)
    const [, link] = getFileComponent(file)
    return [file, link]
}

export function getFileComponent(html) {
    if (!html || String(html).trim() === '') return []

    const value = String(html).trim()
    const hrefRegex = /href\s*=\s*(['"])(https?:\/\/.+?)\1/i
    const hrefMatch = value.match(hrefRegex)

    if (hrefMatch?.[2]) {
        return [getFileName(hrefMatch[2]), hrefMatch[2]]
    }

    const urlRegex = /(https?:\/\/[^\s"'<>]+)/i
    const urlMatch = value.match(urlRegex)

    if (urlMatch?.[1]) {
        return [getFileName(urlMatch[1]), urlMatch[1]]
    }

    return []
}

export const getFirstfile = (html) => {
    return html.split('</a>')[0]
}

export const rewriteOrderIdInFiles = async (order) => {
    if (!order) return

    log('Rewriting Order Id in Files', order)

    const files = getDeliverableFilesFromOrder(order)
    const order_id = order.id

    const generateFileName = ({ name, url }) => {
        const awsS3URL = 'https://olm-customers-assets.s3.amazonaws.com'
        const folderName = url.replace(awsS3URL, '').replace(name, '')
        const fileName = `${'rewritingFile-'}${folderName}${name}`

        return fileName
    }

    const rewriteFiles = (files) => {
        Promise.all(
            [...files].map(
                (file) =>
                    new Promise((resolve, reject) => {
                        const [name, url] = file
                        const complete = (data) => {
                            const fileName = generateFileName({ name, url })
                            data.data = data.data.map((item) => {
                                item.order_id = order_id
                                // item.order = order_id
                                return item
                            })
                            const fileToUpload = CSV.createFile(
                                data.data,
                                fileName,
                            )
                            resolve(fileToUpload)
                        }
                        return CSV.parseRemoteFile({
                            file: url,
                            complete: complete,
                            error: reject,
                        })
                    }),
            ),
        )
            .then(async (filesToUpload) => {
                await FileAPI.uploadFiles(filesToUpload, order)
            })
            .catch((err) => console.log('Something went wrong:', err))
    }

    await rewriteFiles(files)
}
